// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "vendors-node_modules_commerce-cart-webcomponents_ui-composite_dist_es_index_js") return "static/chunks/" + chunkId + "-1.105.43.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".1.105.43.js";
};